import { Injectable } from "@angular/core";

import { tags } from "@lezer/highlight";
import { Extension, Prec } from "@codemirror/state";
import { HighlightStyle, syntaxHighlighting } from "@codemirror/language";

import { CodeEditorThemeService } from "../../services/code-editor-theme.service";


@Injectable()
export class SqlEditorThemeService {

    constructor(private themeService: CodeEditorThemeService) {
    }

    public getThemeExtension(): Extension {

        const theme: Extension[] = this.themeService.getThemeExtension();

        const highlightStyle: Extension = this.getHighlightStyleExtension();

        return [...theme, highlightStyle];
    }

    public getHighlightStyleExtension(): Extension {
        const style: HighlightStyle = HighlightStyle.define([
            { tag: tags.name, color: "#ffffff" }, // Make identifiers strings white.
        ])
        return Prec.high(syntaxHighlighting(style));
    }
}